import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import styles from "./NotFound.module.css";
import { FixaModalBody } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalBody";
import AllenKeyImage from "@coworker/app/src/assets/images/allen-key.png";
import FixaImage from "@coworker/apprestructured/src/shared/wrappers/FixaImage/FixaImage";
import ModalColumn from "../ModalColumn/ModalColumn";

type NotFoundProps = {
  title: string;
  message: string;
};

export const NotFound = ({ title, message }: NotFoundProps) => {
  return (
    <FixaModalBody>
      <ModalColumn gap="medium">
        <FixaImage src={AllenKeyImage} className={styles["image"]} />
        <div className={styles["textWrapper"]}>
          <FixaText textStyle="Heading.L">{title}</FixaText>
          <FixaText textStyle="Body.L">{message}</FixaText>
        </div>
      </ModalColumn>
    </FixaModalBody>
  );
};
